function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from 'react';
import { useObservableEagerState } from 'observable-hooks';
import { styled, ThemeProvider, useTheme } from '@mui/material';
import { deepMergeObjects, PaletteModeCode, useClientService, useIsGorillaTheme, useThemeService } from '@procom-labs/common';
var excludedProps = [
    'isDarkMode',
    'isLightMode',
    'isGlassMode',
    'isThemeBackgroundApplied',
    'forceCreateTheme',
    'themeMode'
];
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function WithGorillaInnerTheme(Component, themeConfig, defaultProps) {
    var StyledComponent = styled(Component, {
        shouldForwardProp: function(prop) {
            return !excludedProps.includes(prop);
        }
    })(function(param) {
        var theme = param.theme, isThemeBackgroundApplied = param.isThemeBackgroundApplied;
        var styles = {};
        if (isThemeBackgroundApplied) {
            styles = {
                color: theme.palette.text.primary,
                background: theme.palette.background.default
            };
        }
        return styles;
    });
    return /*#__PURE__*/ forwardRef(function(props, ref) {
        var clientService = useClientService();
        var themeService = useThemeService();
        var theme = useTheme();
        var clientSettings = useObservableEagerState(clientService.clientSetting$);
        var isGorillaTheme = useIsGorillaTheme();
        var paletteModeCode = useMemo(function() {
            if (props === null || props === void 0 ? void 0 : props.themeMode) {
                return props === null || props === void 0 ? void 0 : props.themeMode;
            }
            if (props === null || props === void 0 ? void 0 : props.isDarkMode) {
                return PaletteModeCode.dark;
            }
            if (props === null || props === void 0 ? void 0 : props.isGlassMode) {
                return PaletteModeCode.glass;
            }
            if (props === null || props === void 0 ? void 0 : props.isLightMode) {
                return PaletteModeCode.light;
            }
            return null;
        }, [
            props === null || props === void 0 ? void 0 : props.themeMode,
            props === null || props === void 0 ? void 0 : props.isDarkMode,
            props === null || props === void 0 ? void 0 : props.isLightMode,
            props === null || props === void 0 ? void 0 : props.isGlassMode
        ]);
        var isModeChanged = paletteModeCode ? paletteModeCode !== theme.palette.mode : false;
        var innerTheme = React.useMemo(function() {
            if (isModeChanged && paletteModeCode && clientSettings && isGorillaTheme) {
                return themeService.getOrCreateTheme(paletteModeCode, clientSettings, props === null || props === void 0 ? void 0 : props.forceCreateTheme, themeConfig);
            }
            return theme;
        }, [
            clientSettings,
            isModeChanged,
            theme,
            paletteModeCode,
            props === null || props === void 0 ? void 0 : props.forceCreateTheme,
            isGorillaTheme
        ]);
        var componentProps = useMemo(function() {
            if (defaultProps) {
                return deepMergeObjects(defaultProps, props);
            }
            return props;
        }, [
            props
        ]);
        return /*#__PURE__*/ _jsx(ThemeProvider, {
            theme: innerTheme,
            children: /*#__PURE__*/ _jsx(StyledComponent, _object_spread_props(_object_spread({}, componentProps), {
                ref: ref
            }))
        });
    });
}
